import { useEffect, useMemo } from 'react';
import { Outlet, useLocation, useNavigate, useOutlet } from 'react-router-dom';
import { TopAppMenu } from 'components/atoms';
import { appPaths } from 'consts/paths/paths';
import { UserType } from 'types';
import { ItemType } from 'antd/es/menu/hooks/useItems';
import { useUserDetails } from 'jotaiAtoms/userDetails';
import {
    accountMenuItems,
    adminAccountMenuItems,
    parentAccountMenuItems,
    supportOwnerMenuItems,
} from './menuItems';

const getAccountLayoutData: (userType?: UserType) => {
    menuItems: ItemType[];
    defaultPath: string;
} = (userType) => {
    switch (userType) {
        case 'SYS_ADMIN': {
            return {
                menuItems: adminAccountMenuItems,
                defaultPath: appPaths.app.admin.account['password-update'],
            };
        }
        case 'PARENT': {
            return {
                menuItems: parentAccountMenuItems,
                defaultPath: appPaths.app.parent.account.details.base,
            };
        }
        case 'SUPPORT_OWNER': {
            return {
                menuItems: supportOwnerMenuItems,
                defaultPath: appPaths.app.account['password-update'],
            };
        }
        case 'OWNER':
        case 'EMPLOYEE':
        default: {
            return { menuItems: accountMenuItems, defaultPath: appPaths.app.account.details.base };
        }
    }
};

export const AccountLayout = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const outlet = useOutlet();

    const { type: userType } = useUserDetails();

    const { menuItems, defaultPath } = useMemo(() => getAccountLayoutData(userType), [userType]);

    useEffect(() => {
        if (outlet) {
            return;
        }
        navigate(defaultPath);
    }, [outlet, navigate, defaultPath]);

    return (
        <>
            <TopAppMenu items={menuItems} selectedKeys={[pathname]} />
            <Outlet />
        </>
    );
};
